class AccountDrawer extends HTMLElement {
    constructor() {
      super();

      if(window.location.pathname === '/account/login') {
        const accountLink = document.querySelector('.header__icon--account');
        accountLink.addEventListener('click', (event) => {
          event.preventDefault();
        });

        return
      }
  
      this.addEventListener('click', (evt) => evt.target.classList.contains("account-drawer-wrapper") && this.close());
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#AccountDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }
  
    setHeaderCartIconAccessibility() {
      const accountLink = document.querySelector('.header__icon--account');
      accountLink.setAttribute('role', 'button');
      accountLink.setAttribute('aria-haspopup', 'dialog');
      accountLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(accountLink);
      });
      accountLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(accountLink);
        }
      });
    }
  
    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });
  
      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = document.getElementById('AccountDrawer');
          const focusElement = this.querySelector('.account-drawer__inner') || this.querySelector('.account-drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );
  
      document.body.classList.add('overflow-hidden');
    }
  
    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define('account-drawer', AccountDrawer);
  